import { render } from "./PackagesManagerSettingsStage.vue?vue&type=template&id=7ecaf8b0&scoped=true"
import script from "./PackagesManagerSettingsStage.vue?vue&type=script&lang=js"
export * from "./PackagesManagerSettingsStage.vue?vue&type=script&lang=js"

import "./PackagesManagerSettingsStage.vue?vue&type=style&index=0&id=7ecaf8b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecaf8b0"]])

export default __exports__